<template>
  <div id="direct-placements-commissions">
    <SimplePageHeader title="Perm. Placements"></SimplePageHeader>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          class="mb-3"
          dense
          :headers="headers"
          :items="directPlacementCommissions"
          :items-per-page="5"
        >
          <template v-slot:item.placementDate="{ item }">
            {{ item.placementDate | formatDate}}
          </template>
          <template v-slot:item.lastPaymentReceivedDate="{ item }">
            {{ item.lastPaymentReceivedDate | formatDate}}
          </template>
          <template v-slot:item.commissionPercentage="{ item }">
            {{ item.commissionPercentage | percent}}
          </template>
          <template v-slot:item.individualGrossProfit="{ item }">
            {{ item.individualGrossProfit | currency}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mx-1 my-1 hide-on-print"
              color="primary"
              outlined
              @click.prevent="handleShowDPDetails($event, item)"
            >
              <v-icon color="primary">work</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { SimplePageHeader } from '@/components/pageComponents'
import { directPlacementEditRoute } from '@/lib/constants/routes'

export default {
  props: [
    'directPlacementCommissions'
  ],
  components: {
    SimplePageHeader
  },
  data () {
    return {
      headers: [
        { text: 'Client', value: 'clientName', class: 'pl-4 pr-0', width: '14%' },
        { text: 'Employee', value: 'employeeName', class: 'pl-4 pr-0', width: '12.5%' },
        { text: 'Job Title', value: 'jobTitle', class: 'hide-on-sm pl-4 pr-0', cellClass: 'hide-on-sm', width: '14%' },
        { text: 'Placement', value: 'placementDate', class: 'hide-on-sm hide-on-print pl-4 pr-0', cellClass: 'hide-on-print hide-on-sm', width: '10%' },
        { text: 'Last Payment Received', value: 'lastPaymentReceivedDate', class: 'hide-on-sm hide-on-print pl-3 pr-0', cellClass: 'hide-on-sm hide-on-print pl-3', width: '14.5%' },
        { text: 'Commission %', value: 'commissionPercentage', class: 'hide-on-sm pl-4 pr-0', cellClass: 'hide-on-sm', width: '12.5%' },
        { text: 'Individual GP', value: 'individualGrossProfit', class: 'pl-4 pr-0', width: '10%' },
        { text: 'Perm. Placement', value: 'actions', align: 'center', width: '12.5%', sortable: false, class: 'hide-on-print', cellClass: 'hide-on-print' }
      ],
      showDirectPlacementDetailInfo: false,
      directPlacementId: null
    }
  },
  methods: {
    ...mapActions('directPlacement', [
      'getDirectPlacement',
      'saveDirectPlacement',
      'clearDirectPlacement'
    ]),
    ...mapActions('directPlacementPayments', [
      'getDirectPlacementsPayments'
    ]),
    handleShowDPDetails (event, item) {
      this.directPlacementId = item.id
      const routeData = this.$router.resolve({
        name: directPlacementEditRoute.name,
        params: { id: this.directPlacementId }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    },
    closeModal () {
      this.showDirectPlacementDetailInfo = false
    }
  }
}
</script>
